import { render, staticRenderFns } from "./guide-books.vue?vue&type=template&id=6de10606"
import script from "./guide-books.vue?vue&type=script&lang=js"
export * from "./guide-books.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports